// apiServiceCompany.js
import axios from 'axios';
import { createHeaders } from './headerUtils';

const BASE_URL = process.env.REACT_APP_BASE_URL;


const AuditServices = {

  getCurrentUser: async () => {
    try {
      const apiUrl = `${BASE_URL}/audit/calendar/user/timezone`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response.data;
    } catch (error) {
      console.error('Error fetching current user profile:', error);
      throw error;
    }
  },
  getUserData: async (userid, startDate, endDate) => {
    try {
        const apiUrl = `${BASE_URL}/audit/alldata/`;
        const headers = createHeaders();
        const params = {};
        
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;
        if (userid) params.userid = userid;
        
        const response = await axios.get(apiUrl, { headers, params });

        return response.data;
      } catch (error) {
        console.log("apiServiceCompany (ERROR): getUserData ", error.message)
        throw error;
      }
  },
  
  getTopUsers: async (module, startDate, endDate, limit = 20) => {
    try {
      const apiUrl = `${BASE_URL}/audit/topusers/`;
      const headers = createHeaders();
      const params = { 
        module, 
        limit,
        startDate,
        endDate
      };
      
      const response = await axios.get(apiUrl, { headers, params });
      return response.data;
    } catch (error) {
      console.log("apiServiceCompany (ERROR): getTopUsers ", error.message);
      throw error;
    }
  },
  
  getUserStats: async (page = 1, limit = 15, startDate, endDate, orderBy = 'totalCount', order = 'desc') => {
    try {
      const apiUrl = `${BASE_URL}/audit/userstats/`;
      const headers = createHeaders();
      const params = {
        page,
        limit,
        startDate,
        endDate,
        orderBy,
        order
      };
      
      const response = await axios.get(apiUrl, { headers, params });
      return response.data;
    } catch (error) {
      console.log("apiServiceCompany (ERROR): getUserStats ", error.message);
      throw error;
    }
  },
  
  getUserTimeSeriesData: async (usernames, startDate, endDate, module = 'all') => {
    try {
      const apiUrl = `${BASE_URL}/audit/usertimeseries/`;
      const headers = createHeaders();
      const params = { 
        usernames: usernames.join(','),
        startDate,
        endDate,
        module
      };
      
      const response = await axios.get(apiUrl, { headers, params });
      return response.data;
    } catch (error) {
      console.log("apiServiceCompany (ERROR): getUserTimeSeriesData ", error.message);
      throw error;
    }
  }
};

export default AuditServices;
